import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './components/login/LoginScreen';
import ProtectedLayout from './components/layout/ProtectedLayout';
import Dashboard from './components/dashboard/Dashboard';
import ProfilePage from './components/profile/ProfilePage';
import MoneyDashboard from './components/money/MoneyDashboard';
import MoneyTransactions from './components/money/MoneyTransactions';
import MoneyReports from './components/money/MoneyReports';
import MoneyCategories from './components/money/MoneyCategories';
import TodayHabits from './components/daily/TodayHabits';
import MonthlyReport from './components/daily/MonthlyReport';
import MyHabits from './components/daily/MyHabits';
import MoneySavings from './components/money/MoneySavings';
import RemindersPage from './components/reminders/RemindersPage';
import NotificationsPage from './components/notifications/NotificationsPage';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginScreen />} />
        <Route element={<ProtectedLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<ProfilePage />} />
          {/* Money Control */}
          <Route path="/money/dashboard" element={<MoneyDashboard />} />
          <Route path="/money/transactions" element={<MoneyTransactions />} />
          <Route path="/money/reports" element={<MoneyReports />} />
          <Route path="/money/categories" element={<MoneyCategories />} />
          <Route path="/money/savings" element={<MoneySavings />} />
          <Route path="/reminders" element={<RemindersPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          {/* Daily Routine (coming soon) */}
          <Route path="/daily/today" element={<TodayHabits />} />
          <Route path="/daily/report" element={<MonthlyReport />} />
          <Route path="/daily/habits" element={<MyHabits />} />
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}